export const basicTheme = colors => ({
  babies: {
    background: colors.babies[100],
    clickable: colors.babies[800],
    form: colors.babies[300],
    hover: colors.babies[800],
    icon: colors.babies[500],
    saturated: colors.babies[300],
    secondary: colors.babies[900],
    text: colors.babies[900],
    focus: colors.babies[900]
  },
  babies_dark: {
    background: colors.babies[300],
    clickable: colors.babies[800],
    form: colors.babies[300],
    hover: colors.babies[800],
    icon: colors.babies[500],
    saturated: colors.babies[300],
    secondary: colors.babies[900],
    text: colors.babies[900],
    focus: colors.babies[900]
  },
  kids: {
    background: colors.kids[100],
    clickable: colors.kids[800],
    form: colors.kids[300],
    hover: colors.kids[800],
    icon: colors.kids[500],
    saturated: colors.kids[300],
    secondary: colors.kids[900],
    text: colors.kids[900],
    focus: colors.kids[900]
  },
  kids_dark: {
    background: colors.kids[300],
    clickable: colors.kids[800],
    form: colors.kids[300],
    hover: colors.kids[800],
    icon: colors.kids[500],
    saturated: colors.kids[300],
    secondary: colors.kids[900],
    text: colors.kids[900],
    focus: colors.kids[900]
  },
  tweens: {
    background: colors.tweens[100],
    clickable: colors.tweens[800],
    form: colors.tweens[300],
    hover: colors.tweens[800],
    icon: colors.tweens[500],
    saturated: colors.tweens[300],
    secondary: colors.tweens[900],
    text: colors.tweens[900],
    focus: colors.tweens[900]
  },
  tweens_dark: {
    background: colors.tweens[300],
    clickable: colors.tweens[800],
    form: colors.tweens[300],
    hover: colors.tweens[800],
    icon: colors.tweens[500],
    saturated: colors.tweens[300],
    secondary: colors.tweens[900],
    text: colors.tweens[900],
    focus: colors.tweens[900]
  },
  teens: {
    background: colors.teens[100],
    clickable: colors.teens[800],
    form: colors.teens[300],
    hover: colors.teens[800],
    icon: colors.teens[500],
    saturated: colors.teens[300],
    secondary: colors.teens[900],
    text: colors.teens[900],
    focus: colors.teens[900]
  },
  teens_dark: {
    background: colors.teens[300],
    clickable: colors.teens[800],
    form: colors.teens[300],
    hover: colors.teens[800],
    icon: colors.teens[500],
    saturated: colors.teens[300],
    secondary: colors.teens[900],
    text: colors.teens[900],
    focus: colors.teens[900]
  },
  franchises_dark: {
    background: colors.neutral?.[800],
    clickable: colors.neutral[100],
    form: colors.neutral[800],
    hover: colors.franquicias?.[100],
    icon: colors.neutral[100],
    saturated: colors.neutral[800],
    secondary: colors.neutral[100],
    text: colors.neutral[100],
    focus: colors.neutral[900]
  },
  franchises_light: {
    background: colors.franquicias?.[100],
    clickable: colors.franquicias?.[500],
    hover: colors.franquicias?.[500],
    icon: colors.franquicias?.[300],
    saturated: colors.franquicias?.[100],
    secondary: colors.franquicias?.[800],
    text: colors.franquicias?.[800]
  },
  neutral: {
    background: colors.neutral[200],
    clickable: colors.primary[600],
    hover: colors.primary[500],
    icon: colors.neutral[800],
    saturated: colors.neutral[200],
    secondary: colors.neutral[900],
    secondaryHover: colors.neutral[800],
    text: colors.neutral[900]
  },
  neutral_dark: {
    background: colors.neutral[900],
    clickable: colors.primary[600],
    hover: colors.primary[100],
    icon: colors.neutral[900],
    saturated: colors.neutral[200],
    secondary: colors.neutral[900],
    secondaryHover: colors.neutral[800],
    text: colors.neutral[100]
  },
  neutral_black: {
    background: colors.neutral[1000],
    clickable: colors.primary[600],
    hover: colors.primary[100],
    icon: colors.neutral[900],
    saturated: colors.neutral[200],
    secondary: colors.neutral[900],
    secondaryHover: colors.neutral[800],
    text: colors.neutral[100]
  },
  white: {
    background: colors.neutral[100],
    clickable: colors.primary[600],
    hover: colors.primary[500],
    icon: colors.neutral[800],
    saturated: colors.neutral[100],
    secondary: colors.neutral[900],
    secondaryHover: colors.neutral[800],
    text: colors.neutral[900]
  },
  dark: {
    background: colors.neutral[900],
    hover: colors.neutral[200],
    icon: colors.neutral[100],
    secondary: colors.neutral[100],
    secondaryHover: colors.neutral[200],
    text: colors.neutral[100]
  }
});
